import { render, staticRenderFns } from "./Controller.vue?vue&type=template&id=572e2468&"
import script from "./Controller.vue?vue&type=script&lang=ts&"
export * from "./Controller.vue?vue&type=script&lang=ts&"
import style0 from "./Controller.vue?vue&type=style&index=0&id=572e2468&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports